const PLATFORM_AC = 'ac';
const PLATFORM_AM = 'am';
const PLATFORM_H2H = 'h2h';
const ALL_PLATFORMS = [PLATFORM_AC, PLATFORM_AM, PLATFORM_H2H];

const THEME_SIZE_POINTS = {
    PX: 'px',
    VW: 'vw'
}

const THEME_COLORS = {
    BLACK: 'black',
    VIOLET: 'violet',
    BLUE: 'blue',
    NAVY_BLUE: 'navy-blue',
    GREEN: 'green',
    RED: 'red',
    YELLOW: 'yellow'
}

const THEME_MODES = {
    DAY: 'day',
    NIGHT: 'night'
}

const THEME_URL_PARAMS = {
    COLOR: 'color',
    MODE: 'mode',
    SCI_PLATFORM: 'sciPlatform',
    APPLY_SIZES_IN_POINTS: 'applySizesInPoints',
    IS_MOBILE: 'isMobile',
    IS_EMBEDDED: 'isEmbedded',
}

export {
    PLATFORM_AC,
    PLATFORM_AM,
    PLATFORM_H2H,
    ALL_PLATFORMS,
    THEME_SIZE_POINTS,
    THEME_COLORS,
    THEME_MODES,
    THEME_URL_PARAMS
}
